import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  Flex,
  Image,
  Select,
  useToast,
  Text,
  Box,
  ButtonGroup,
  VStack,
  Textarea,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Notification from "../../services/Notification";

export default function CreateAppNotificationModal({
  isOpen,
  onClose,
  func,
}: any) {
  const initialRef = React.useRef(null);

  const toast = useToast();

  const [data, setData] = useState({
    name: "",
    title: "",
    body: "",
    path: "",
    image_url: "",
    category: "dolphin",
  });

  const createAppNotification = async () => {
    await Notification.createNotification(data)
      .then((res) => {
        toast({
          position: "top",
          title: "App Notification Created.",
          description: "App Notification created successfully.",
          status: "success",
          duration: 1000,
          isClosable: true,
        });
        setData({
          name: "",
          title: "",
          body: "",
          path: "",
          image_url: "",
          category: "dolphin",
        });
      })
      .catch((error: any) => {
        toast({
          position: "top",
          title: "Create App Notification Failed.",
          description: "App Notification not created.",
          status: "error",
          duration: 500,
          isClosable: true,
        });
        console.log(error);
      });
  };

  const handleChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Modal
        size="xl"
        initialFocusRef={initialRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.3)" />
        <ModalContent>
          <ModalHeader>Create App Notification</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <div className="mt-4">
              <FormControl>
                <FormLabel>Name</FormLabel>
                <Input name="name" value={data.name} onChange={handleChange} />
              </FormControl>

              <FormControl mt={2}>
                <FormLabel>Title</FormLabel>
                <Input
                  name="title"
                  value={data.title}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl mt={2}>
                <FormLabel>Body</FormLabel>
                <Textarea
                  name="body"
                  value={data.body}
                  onChange={handleChange}
                  size="sm"
                />
              </FormControl>

              <FormControl mt={2}>
                <FormLabel>Path</FormLabel>
                <Input name="path" value={data.path} onChange={handleChange} />
              </FormControl>

              <FormControl mt={2}>
                <FormLabel>Image URL</FormLabel>
                <Input
                  name="image_url"
                  value={data.image_url}
                  onChange={handleChange}
                />
              </FormControl>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={() => {
                createAppNotification();
                func();

                onClose();
              }}
            >
              Submit
            </Button>
            <Button
              bgColor="red"
              color={"white"}
              onClick={() => {
                setData({
                  name: "",
                  title: "",
                  body: "",
                  path: "",
                  image_url: "",
                  category: "dolphin",
                });
                onClose();
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
